import { Component, OnInit } from '@angular/core';
import { HomeService } from '../home/home.service';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { Formatter } from '../common/services/formatter';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { VerifyOfficialEmailService } from './verifyOfficialEmail.service';
import { CommonUtility } from '../common/services/commonUtility';
@Component({
    selector: 'app-verify-official-email',
    templateUrl: './verifyOfficialEmail.template.html',
    styleUrls: ['./verifyOfficialEmail.style.css'],
    providers: [VerifyOfficialEmailService]
})
export class VerifyOfficialEmailComponent implements OnInit {
    public consentAlreadyCaptured:boolean;
    public captureSuccess:boolean;
    public token:string;
    public channel;
    public isError:boolean;
    private applicationId: string;
    public isBusinessError:boolean;
    public errorMessage = '';
    public successMessage: string = "";
    constructor(
        private _homeService: HomeService,
        private _cookieHandler: CookieHandlerService,
        private _formatter: Formatter,
        private _routeContextProvider: RouteContextProvider,
        private _verifyOfficialEmailService: VerifyOfficialEmailService
    ) { }
    public ngOnInit() {
        this.checkQueryParams();
        // if(this.consentType === "APPROVAL_MAIL") {
        //     this.generateSytemToken();
        // }else {
        this.authenticateSystem();
        // }
       
    }

    private checkQueryParams(): void {
        this.token = encodeURIComponent(this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.token))
        this.applicationId = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.applicationid);
        this.channel = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.consentChannel);
    }

    private authenticateSystem(): void {
        const userClientId = this._homeService.GetClientIdForUser();
        this.setSecretKeyForClientId(userClientId);
    }
    private setSecretKeyForClientId(clientId: string): void {
        this._homeService.GetSecretKeyForBasedOnClientId(clientId).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
            if (!responseData.errorBean) {
                this._cookieHandler
                    .SetCookie(CommonConstants.CookieKeys.ClientId, clientId);
                this._cookieHandler
                    .SetCookie(CommonConstants.CookieKeys.SecretKey,
                        responseData.payload.secretKey);
                this.setSystemAuthToken(responseData.payload.secretKey, clientId);
            }
        });
    }
    private setSystemAuthToken(secretKey: string, clientId: string): void {
        this._homeService.GetSystemAuthToken({
            secretKey,
            clientId
        }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
            if (!responseData.errorBean) {
                const tokenObj = responseData.payload.tokens[0];
                console.log('tokens::', tokenObj);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.JWToken, tokenObj.token);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.JWTokenCO, tokenObj.token);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardKey, tokenObj.guardKey);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardKeyCO, tokenObj.guardKey);
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardToken, this._formatter
                    .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
                this._cookieHandler.SetCookie(CommonConstants.CookieKeys.GuardTokenCO, this._formatter
                    .ConvertGuradKeyToGuardToken(tokenObj.guardKey));
                    this.getOfficialEmailId();
            }
        });
    }

    private getOfficialEmailId(){
        this._verifyOfficialEmailService.getOfficialEmailId(this.applicationId).subscribe((response: any)=>{
            if (CommonUtility.isValidResponse(response)) {
                console.log(response);
                let reqdata = {
                    "email": response.email,
                    "typeKey": 67,
                    "verified": true
                }
                this.validateEmail(reqdata);
            } else if (response.error && response.error.errorCode ) {
                this.isBusinessError = true;
                this.errorMessage = response.error.errorMessage;
            } else {
                this.isError = true;
            }
    },
    (error) => {
        console.log(error);
        this.isError = true;
    });

    }

    private validateEmail(req){
        this._verifyOfficialEmailService.validateEmail(req,this.applicationId,this.token).subscribe((response: any)=>{
            if (CommonUtility.isValidResponse(response)) {
                console.log(response);
                if(response.verificationProcessStatus === "COMPLETED" && response.status === "VERIFIED"){
                    this.captureSuccess = true;
                }
            } else if (response.error && response.error.errorCode ) {
                this.isBusinessError = true;
                this.errorMessage = response.error.errorMessage;
            } else {
                this.isError = true;
            }
    },
    (error) => {
        console.log(error);
        this.isError = true;
    });

    }

}
